import { render, staticRenderFns } from "./Odessa.vue?vue&type=template&id=6ae1c522"
import script from "./Odessa.vue?vue&type=script&lang=js"
export * from "./Odessa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports